import { Routes, Route } from "react-router-dom";
import ApplicationDashboard from "../../Pages/ApplicationProcessor/ApplicationDashboard";
import ApplicationLayout from "./ApplicationLayout";
import ApplicationProcessor from "../../Pages/ApplicationProcessor/ApplicationProcessor";
import AddApplication from "../../Pages/ApplicationProcessor/AddApplication";
import ErrorPage from "../../ErrorPage";



const ApplicationRoute = () => {
  return (
    <ApplicationLayout>
      <Routes>
        <Route path="dashboard" element={<ApplicationDashboard />} />
        <Route path="view" element={<ApplicationProcessor />} />
        <Route path="add" element={<AddApplication />} />
        {/* Add hideSidebar prop here */}
        <Route path="*" element={
          <ApplicationLayout hideSidebar={true}>
            <ErrorPage />
          </ApplicationLayout>
        } />
      </Routes>
    </ApplicationLayout>
  );
};

export default ApplicationRoute;
